
//import React, { useState, useEffect, useMemo } from "react";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  UserCheck,
  Edit2,
  CheckSquare,
  Square,
} from "lucide-react";

import API_URL from "../config";

const API = `${API_URL}/api`;

export default function GestionarUsuarios() {

  const [usuarios, setUsuarios] = useState([]);
  const [niveles, setNiveles] = useState([]);
  const [grados, setGrados] = useState([]);

  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("profesor");

  const [nivelId, setNivelId] = useState("");
  const [gradoId, setGradoId] = useState("");

  const [editando, setEditando] = useState(null);

  const [search, setSearch] = useState("");
  const [filtroNivel, setFiltroNivel] = useState("todos");
  const [filtroEstado, setFiltroEstado] = useState("activo");

  // 🔥 Pestaña por rol — antes se veían admins, docentes y padres todos
  // mezclados en la misma tabla. Los padres se crean solos al iniciar
  // sesión con Google (ver backend/routes/auth.js), así que con el tiempo
  // esa lista crece mucho — separarlos hace la pantalla usable.
  const [rolTab, setRolTab] = useState("profesor"); // "profesor" | "padre" | "admin"

  const [selected, setSelected] = useState([]);

const [foto, setFoto] = useState(null);
const fileInputRef = useRef(null);

/* ================= PAGINACION ================= */
const [paginaActual, setPaginaActual] = useState(1);
const usuariosPorPagina = 20;


/* ================= LOAD ================= */
useEffect(() => {
  cargar();
  fetch(`${API}/usuarios/niveles`)
    .then(r => r.json())
    .then(data => setNiveles(Array.isArray(data) ? data : []));
  fetch(`${API}/usuarios/grados`)
    .then(r => r.json())
    .then(data => setGrados(Array.isArray(data) ? data : []));
}, []);

/* ================= RESET PAGINA ================= */
useEffect(() => {
  setPaginaActual(1);
}, [search, filtroNivel, filtroEstado, rolTab]);

const cargar = async () => {
  const res = await fetch(`${API}/usuarios`);
  const data = await res.json();
  setUsuarios(Array.isArray(data) ? data : []);
};

  /* ================= GUARDAR ================= */
/* ================= GUARDAR ================= */

const guardar = async (e) => {
  e.preventDefault();

  const body = {
    nombre,
    email,
    role,
    nivel_id: role === "profesor" ? nivelId || null : null,
    grado_id: role === "profesor" ? gradoId || null : null,
  };

  const url = editando
    ? `${API}/usuarios/${editando.id}`
    : `${API}/usuarios`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    console.log("STATUS:", response.status);
    console.log("OK:", response.ok);

    const texto = await response.text();
    console.log("RESPUESTA:", texto);

    const data = texto ? JSON.parse(texto) : {};

    // Si falló, no seguimos
    if (!response.ok) {
      alert(data.message || `Error ${response.status}`);
      return;
    }

    const usuarioId = editando ? editando.id : data.id;

    if (foto && role === "profesor") {
      const formData = new FormData();
      formData.append("foto", foto);

      await fetch(`${API}/usuarios/${usuarioId}/foto`, {
        method: "POST",
        body: formData,
      });
    }

    limpiar();
    cargar();

  } catch (err) {
    console.error("ERROR:", err);
  }
};


  /* ================= LIMPIAR ================= */
const limpiar = () => {
  setNombre("");
  setEmail("");
  setRole("profesor");
  setNivelId("");
  setGradoId("");
  setFoto(null);
  setEditando(null);

  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

  /* ================= EDITAR ================= */
  const editar = (u) => {
    setEditando(u);
    setNombre(u.nombre || "");
    setEmail(u.email || "");
    setRole(u.role || "profesor");

    setNivelId(u.nivel_id || "");
    setGradoId(u.grado_id || "");
  };

  /* ================= CAMBIO DE ROL (IMPORTANTE FIX) ================= */
  const cambiarRol = (r) => {
    setRole(r);

    if (r !== "profesor") {
      setNivelId("");
      setGradoId("");
    }
  };

  /* ================= SELECT ================= */
  const toggleSelect = (id) => {
    setSelected(p =>
      p.includes(id) ? p.filter(x => x !== id) : [...p, id]
    );
  };





/* ================= ACTIVAR/DESACTIVAR ================= */
const cambiarEstadoMasivo = async (activo) => {

  if (selected.length === 0) {
    alert("Selecciona usuarios");
    return;
  }

  try {

    await fetch(
      `${API}/usuarios/estado/masivo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ids: selected,
          activo,
        }),
      }
    );

    setSelected([]);
    cargar();

  } catch (err) {

    console.error(err);
  }
};



const usuariosFiltrados = useMemo(() => {
  return usuarios.filter(u => {

    const q = search.toLowerCase();

    const matchRol = (u.role || "") === rolTab;

    const matchTexto =
      (u.nombre || "").toLowerCase().includes(q) ||
      (u.email || "").toLowerCase().includes(q);

    const matchNivel =
      filtroNivel === "todos" || u.nivel_id == filtroNivel;

    const matchEstado =
      filtroEstado === "todos" ||
      (filtroEstado === "activo" && u.activo == 1) ||
      (filtroEstado === "inactivo" && u.activo == 0);

    return matchRol && matchTexto && matchNivel && matchEstado;
  });
}, [usuarios, search, filtroNivel, filtroEstado, rolTab]);

/* ================= PAGINACION ================= */
const totalPaginas = Math.ceil(
  usuariosFiltrados.length / usuariosPorPagina
);

const indiceInicial =
  (paginaActual - 1) * usuariosPorPagina;

const usuariosPaginados =
  usuariosFiltrados.slice(
    indiceInicial,
    indiceInicial + usuariosPorPagina
  );





  return (
    <div className="space-y-6">

      <h2 className="text-2xl font-bold flex gap-2">
        <UserCheck /> Usuarios
      </h2>

      {/* ================= PESTAÑAS POR ROL ================= */}
      <div className="flex gap-2 border-b">
        {[
          { id: "profesor", label: "👩‍🏫 Docentes" },
          { id: "padre", label: "👨‍👩‍👧 Padres de Familia" },
          { id: "admin", label: "🛡️ Administradores" },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setRolTab(t.id)}
            className={`px-4 py-2 font-semibold border-b-2 transition ${
              rolTab === t.id
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ================= FORM ================= */}
      {/* Los padres se crean solos al iniciar sesión con Google — no se
          crean ni editan manualmente desde aquí, por eso este formulario
          solo aparece en las pestañas de Docentes y Administradores. */}
      {rolTab !== "padre" && (
      <form onSubmit={guardar} className="bg-white p-4 space-y-2 rounded">

        <input
          value={nombre}
          onChange={e => setNombre(e.target.value)}
          placeholder="Nombre"
          className="border p-2 w-full"
        />

        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Email"
          className="border p-2 w-full"
        />

        <select
          value={role}
          onChange={e => cambiarRol(e.target.value)}
          className="border p-2 w-full"
        >
          <option value="profesor">Profesor</option>
          <option value="admin">Admin</option>
        </select>

        {/* SOLO PROFESOR */}
        {role === "profesor" && (
          <>
            <select
              value={nivelId}
              onChange={e => setNivelId(e.target.value)}
              className="border p-2 w-full"
            >
              <option value="">Nivel</option>
              {niveles.map(n => (
                <option key={n.id} value={n.id}>{n.nombre}</option>
              ))}
            </select>

            <select
              value={gradoId}
              onChange={e => setGradoId(e.target.value)}
              className="border p-2 w-full"
            >
              <option value="">Grado</option>
              {grados.map(g => (
                <option key={g.id} value={g.id}>{g.nombre}</option>
              ))}
            </select>
          </>
        )}


<input
  ref={fileInputRef}
  type="file"
  accept="image/*"
  onChange={(e) => setFoto(e.target.files[0])}
  className="border p-2 w-full"
/>


        <button className="bg-blue-600 text-white px-4 py-2 rounded">
          {editando ? "Actualizar" : "Crear"}
        </button>

      </form>
      )}

      {/* ================= TABLE ================= */}
      <div className="bg-white rounded shadow overflow-x-auto">


{/* ================= ACCIONES ================= */}
<div className="
  bg-white
  p-4
  rounded
  shadow
  flex
  flex-wrap
  gap-3
  items-center
">

  {/* BUSCADOR */}
  <input
    type="text"
    placeholder="Buscar usuario..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="border p-2 rounded w-64"
  />

  {/* FILTRO NIVEL — solo aplica a Docentes */}
  {rolTab === "profesor" && (
    <select
      value={filtroNivel}
      onChange={(e) => setFiltroNivel(e.target.value)}
      className="border p-2 rounded w-48"
    >
      <option value="todos">Todos los niveles</option>

      {niveles.map(n => (
        <option key={n.id} value={n.id}>
          {n.nombre}
        </option>
      ))}
    </select>
  )}

  {/* FILTRO ESTADO */}
  <select
    value={filtroEstado}
    onChange={(e) => setFiltroEstado(e.target.value)}
    className="border p-2 rounded w-40"
  >
    <option value="activo">Activos</option>
    <option value="inactivo">Inactivos</option>
    <option value="todos">Todos</option>
  </select>

  {/* BOTONES */}
  <button
    onClick={() =>
      setSelected(
        selected.length === usuariosFiltrados.length
          ? []
          : usuariosFiltrados.map(u => u.id)
      )
    }
    className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded"
  >
    Seleccionar todos
  </button>

  <button
    onClick={() => cambiarEstadoMasivo(1)}
    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
  >
    Activar
  </button>

  <button
    onClick={() => cambiarEstadoMasivo(0)}
    className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded"
  >
 Inactivar 



  </button>

</div>








        <table className="w-full text-sm">

          <thead className="bg-blue-600 text-white">
            <tr>
              <th></th>
              {rolTab === "profesor" && <th>Foto</th>}
              <th>Nombre</th>
              <th>Email</th>
              {rolTab === "profesor" && <th>Nivel</th>}
              {rolTab === "profesor" && <th>Grados</th>}
              <th>Estado</th>
              {rolTab !== "padre" && <th></th>}
            </tr>
          </thead>

          <tbody>
           {usuariosPaginados.map(u => (
              <tr key={u.id} className="border-b">

                <td>
                  <button onClick={() => toggleSelect(u.id)}>
                    {selected.includes(u.id) ? <CheckSquare /> : <Square />}
                  </button>
                </td>

                {/* FOTO */}
                {rolTab === "profesor" && (
                  <td>
                    {u.foto ? (
                      <img
                        src={u.foto}
                        className="w-10 h-10 rounded-full object-cover"
                        alt="foto"
                      />
                    ) : (
                      <div className="w-10 h-10 bg-gray-200 rounded-full" />
                    )}
                  </td>
                )}

                <td>{u.nombre}</td>
                <td>{u.email}</td>
                {rolTab === "profesor" && <td>{u.nivel || "-"}</td>}
                {rolTab === "profesor" && <td>{u.grados || "-"}</td>}

                <td className={u.activo ? "text-green-600" : "text-red-600"}>
                  {u.activo ? "Activo" : "Inactivo"}
                </td>

                {rolTab !== "padre" && (
                  <td>
                    <button onClick={() => editar(u)}>
                      <Edit2 size={16} />
                    </button>
                  </td>
                )}

              </tr>
            ))}
          </tbody>

        </table>

<div className="flex justify-center items-center gap-2 p-4">

  <button
    disabled={paginaActual === 1}
    onClick={() =>
      setPaginaActual(p => p - 1)
    }
    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
  >
    Anterior
  </button>

  <span>
    Página {paginaActual} de {totalPaginas || 1}
  </span>

  <button
    disabled={paginaActual === totalPaginas}
    onClick={() =>
      setPaginaActual(p => p + 1)
    }
    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
  >
    Siguiente
  </button>

</div>

      </div>

    </div>
  );
}